(function () {
  var MODELS_OPTION = 'models';
  var LETTER_OPTION = 'letter';
  var LETTER_GARDEN_VALUE = 'Letter Garden';
  var DEFAULT_LETTER_VALUE = 'A';

  function getSelectedValue(optionRoot) {
    if (!optionRoot) return null;
    var checked = optionRoot.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var select = optionRoot.querySelector('select');
    return select ? select.value : null;
  }

  function setNativeSelectValue(select, value) {
    var option = null;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) {
        option = select.options[i];
        break;
      }
    }
    if (!option) {
      throw new Error('[diy-flower-letter-gate] Letter option value "' + value + '" not found');
    }
    if (select.value === value && option.selected) return false;
    for (var j = 0; j < select.options.length; j++) {
      select.options[j].removeAttribute('selected');
    }
    select.value = value;
    option.setAttribute('selected', 'selected');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function clearNativeSelectToBlank(select) {
    var blank = null;
    for (var i = 0; i < select.options.length; i++) {
      if (!select.options[i].value) {
        blank = select.options[i];
        break;
      }
    }
    if (!blank) {
      throw new Error('[diy-flower-letter-gate] Blank Letter option missing');
    }
    if (!select.value && blank.selected) return false;
    for (var j = 0; j < select.options.length; j++) {
      select.options[j].removeAttribute('selected');
    }
    select.value = '';
    blank.selected = true;
    blank.setAttribute('selected', 'selected');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function forceLetterA(letterRoot) {
    var select = letterRoot.querySelector('select');
    if (select) {
      setNativeSelectValue(select, DEFAULT_LETTER_VALUE);
      if (typeof letterRoot._diyFlowerComboboxSetEmpty === 'function') {
        letterRoot._diyFlowerComboboxSetEmpty();
      }
      return;
    }

    var radio = letterRoot.querySelector(
      'input[type="radio"][value="' + DEFAULT_LETTER_VALUE + '"]'
    );
    if (!radio) {
      throw new Error('[diy-flower-letter-gate] Letter radio value "A" not found');
    }
    if (radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function readSelectOptions(select) {
    var items = [];
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!opt.value) continue;
      items.push({
        value: opt.value,
        label: (opt.textContent || opt.value).trim(),
        available: opt.getAttribute('data-available') !== 'false',
      });
    }
    return items;
  }

  function initLetterCombobox(root, letterRoot) {
    if (!letterRoot || !letterRoot.hasAttribute('data-diy-flower-letter-combobox')) return;
    if (letterRoot.querySelector('.amc-diy-flower-letter-combo')) return;

    var select = letterRoot.querySelector('select');
    if (!select) {
      throw new Error('[diy-flower-letter-gate] Letter select missing for combobox');
    }

    if (typeof letterRoot._diyFlowerComboCleanup === 'function') {
      letterRoot._diyFlowerComboCleanup();
    }

    var items = readSelectOptions(select);
    if (!items.length) {
      throw new Error('[diy-flower-letter-gate] Letter select has no values');
    }

    var wrap = select.closest('.select') || letterRoot;
    var listId = 'DiyFlowerLetterList-' + select.id;
    var inputId = 'DiyFlowerLetter-' + select.id;

    var ui = document.createElement('div');
    ui.className = 'amc-diy-flower-letter-combo';
    ui.innerHTML =
      '<div class="amc-diy-flower-letter-combo__control">' +
      '<input type="text" class="amc-diy-flower-letter-combo__input" id="' +
      inputId +
      '" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' +
      listId +
      '" autocomplete="off" spellcheck="false" placeholder="Type or choose a letter" />' +
      '<span class="amc-diy-flower-letter-combo__caret" aria-hidden="true"></span>' +
      '</div>' +
      '<ul class="amc-diy-flower-letter-combo__list hidden" id="' +
      listId +
      '" role="listbox"></ul>';

    wrap.appendChild(ui);

    var input = ui.querySelector('.amc-diy-flower-letter-combo__input');
    var list = ui.querySelector('.amc-diy-flower-letter-combo__list');
    var open = false;
    var activeIndex = -1;
    var filtered = items.slice();

    function setDisplay(value) {
      input.value = value || '';
      activeIndex = -1;
    }

    function setEmpty() {
      setDisplay('');
    }

    function setOpen(next) {
      open = next;
      list.classList.toggle('hidden', !open);
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) activeIndex = -1;
    }

    function renderList(query) {
      var q = String(query || '').trim().toLowerCase();
      filtered = items.filter(function (item) {
        if (!q) return true;
        return (
          item.value.toLowerCase().indexOf(q) === 0 ||
          item.label.toLowerCase().indexOf(q) === 0
        );
      });

      list.innerHTML = '';
      if (!filtered.length) {
        var empty = document.createElement('li');
        empty.className = 'amc-diy-flower-letter-combo__empty';
        empty.textContent = 'No match';
        list.appendChild(empty);
        activeIndex = -1;
        return;
      }

      filtered.forEach(function (item, index) {
        var li = document.createElement('li');
        li.className = 'amc-diy-flower-letter-combo__option';
        if (!item.available) li.className += ' is-unavailable';
        if (item.value === select.value) li.className += ' is-selected';
        li.setAttribute('role', 'option');
        li.setAttribute('data-index', String(index));
        li.setAttribute('aria-selected', item.value === select.value ? 'true' : 'false');
        li.textContent = item.label;
        if (!item.available) li.setAttribute('aria-disabled', 'true');
        list.appendChild(li);
      });
    }

    function highlight(index) {
      var options = list.querySelectorAll('.amc-diy-flower-letter-combo__option');
      options.forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (index < 0 || index >= options.length) {
        activeIndex = -1;
        return;
      }
      activeIndex = index;
      options[index].classList.add('is-active');
      options[index].scrollIntoView({ block: 'nearest' });
    }

    function choose(item) {
      if (!item || !item.available) return;
      root._diyFlowerLetterUserValue = item.value;
      setNativeSelectValue(select, item.value);
      setDisplay(item.value);
      setOpen(false);
    }

    function onDocClick(event) {
      if (!ui.isConnected) {
        document.removeEventListener('click', onDocClick);
        return;
      }
      if (!ui.contains(event.target)) setOpen(false);
    }

    input.addEventListener('focus', function () {
      // Empty query → full A–Z list
      renderList(input.value);
      setOpen(true);
      if (input.value) input.select();
    });

    input.addEventListener('input', function () {
      renderList(input.value);
      setOpen(true);
      highlight(filtered.length ? 0 : -1);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!open) {
          renderList(input.value);
          setOpen(true);
        }
        highlight(Math.min(activeIndex + 1, filtered.length - 1));
        return;
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(Math.max(activeIndex - 1, 0));
        return;
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        if (open && activeIndex >= 0 && filtered[activeIndex]) {
          choose(filtered[activeIndex]);
        } else {
          var exact = items.find(function (item) {
            return item.value.toLowerCase() === String(input.value || '').trim().toLowerCase();
          });
          if (exact) choose(exact);
        }
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        setDisplay(root._diyFlowerLetterUserValue || '');
        setOpen(false);
        input.blur();
      }
    });

    list.addEventListener('mousedown', function (event) {
      var optionEl = event.target.closest('.amc-diy-flower-letter-combo__option');
      if (!optionEl) return;
      event.preventDefault();
      var index = Number(optionEl.getAttribute('data-index'));
      choose(filtered[index]);
    });

    document.addEventListener('click', onDocClick);

    letterRoot._diyFlowerComboCleanup = function () {
      document.removeEventListener('click', onDocClick);
    };
    letterRoot._diyFlowerComboboxSetEmpty = setEmpty;
    letterRoot._diyFlowerComboboxSetDisplay = setDisplay;

    if (root._diyFlowerLetterUserValue) {
      setDisplay(root._diyFlowerLetterUserValue);
    } else {
      setEmpty();
    }
  }

  function sync(root) {
    var modelsRoot = root.querySelector('[data-option-name="' + MODELS_OPTION + '"]');
    var letterRoot = root.querySelector('[data-option-name="' + LETTER_OPTION + '"]');
    if (!modelsRoot || !letterRoot) {
      throw new Error(
        '[diy-flower-letter-gate] Expected options named Models and Letter on diy-flower template'
      );
    }

    initLetterCombobox(root, letterRoot);

    var showLetter = getSelectedValue(modelsRoot) === LETTER_GARDEN_VALUE;
    letterRoot.classList.toggle('hidden', !showLetter);
    letterRoot.setAttribute('aria-hidden', showLetter ? 'false' : 'true');

    if (!showLetter) {
      root._diyFlowerLetterUserValue = null;
      forceLetterA(letterRoot);
      return;
    }

    var select = letterRoot.querySelector('select');
    var userValue = root._diyFlowerLetterUserValue || null;

    if (userValue) {
      if (typeof letterRoot._diyFlowerComboboxSetDisplay === 'function') {
        letterRoot._diyFlowerComboboxSetDisplay(userValue);
      }
      if (select && select.value !== userValue) {
        setNativeSelectValue(select, userValue);
      }
      return;
    }

    if (typeof letterRoot._diyFlowerComboboxSetEmpty === 'function') {
      letterRoot._diyFlowerComboboxSetEmpty();
    }
    if (select && select.value) {
      clearNativeSelectToBlank(select);
    }
  }

  function ensure(root) {
    if (root._diyFlowerLetterGateEnsuring) return;
    root._diyFlowerLetterGateEnsuring = true;
    try {
      sync(root);
    } finally {
      root._diyFlowerLetterGateEnsuring = false;
    }
  }

  function init(root) {
    if (!root) return;

    if (root.dataset.diyFlowerLetterGateBound !== 'true') {
      root.dataset.diyFlowerLetterGateBound = 'true';

      root.addEventListener('change', function () {
        ensure(root);
      });

      var observer = new MutationObserver(function () {
        ensure(root);
      });
      observer.observe(root, { childList: true });
    }

    ensure(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-diy-flower-letter-gate]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
